import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { DoorOpen, Loader2 } from "lucide-react";
import { toast } from "sonner";

// Self-service account deletion (App Store 5.1.1): deactivate now, officers can restore for 30 days, then personal data is erased
export default function LeaveVessel() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const leave = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/leave", { password, confirm });
      setUser(null); toast.success(data.message); navigate("/login", { replace: true });
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Card className="glass border-destructive/30 p-6 lg:col-span-3" data-testid="leave-vessel-card">
      <div className="flex items-center gap-2"><DoorOpen className="h-5 w-5 text-destructive" /><h3 className="font-display text-lg font-700">Leave the Vessel</h3></div>
      <p className="mt-2 text-sm text-muted-foreground">Delete your account. It is deactivated immediately and you are signed out everywhere. An officer can restore you within 30 days if you change your mind; after that your personal details are erased for good. Your past posts remain in the brotherhood's record as “Departed Brother”.</p>
      <Button variant="outline" className="mt-4 border-destructive/50 text-destructive hover:bg-destructive hover:text-white" onClick={() => setOpen(true)} data-testid="leave-vessel-button">Delete my account</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="glass" data-testid="leave-vessel-dialog">
          <DialogHeader><DialogTitle className="font-display">Leave the Vessel?</DialogTitle></DialogHeader>
          <p className="text-sm text-muted-foreground">Confirm with your password and type <b>LEAVE</b>.</p>
          <div className="space-y-3">
            <div><Label>Password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="leave-password-input" /></div>
            <div><Label>Type LEAVE</Label><Input value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="LEAVE" data-testid="leave-confirm-input" /></div>
          </div>
          <Button onClick={leave} disabled={busy || !password || confirm.trim().toUpperCase() !== "LEAVE"} className="bg-destructive text-white hover:bg-destructive/90" data-testid="leave-submit-button">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Deactivate and sign out"}</Button>
        </DialogContent>
      </Dialog>
    </Card>
  );
}
